export default __webpack_public_path__ + "static/slide3-03c57442bdbc5b23abc66e49d8aee241.jpg";